import { render, staticRenderFns } from "./ClientFolders.vue?vue&type=template&id=1dc1376e&scoped=true"
import script from "./ClientFolders.vue?vue&type=script&lang=js"
export * from "./ClientFolders.vue?vue&type=script&lang=js"
import style0 from "./ClientFolders.vue?vue&type=style&index=0&id=1dc1376e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1376e",
  null
  
)

export default component.exports